import { createStore } from 'vuex'

export default createStore({
  state: {
    activeTab:0, 
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
